"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var client_lib_js_common_request_1 = require("@sky-uk-ott/client-lib-js-common-request");
exports.generateWidevineLicenseRequest = function (drmConfiguration, message, messageType) {
    var httpRequestDescription = {
        url: drmConfiguration.licenceAcquisitionUrl,
        method: 'POST',
        body: message.buffer,
        headers: {},
    };
    return httpRequestDescription;
};
exports.widevineRequestFunction = function (url, options, xhr) {
    var preparedXhr = xhr || new XMLHttpRequest();
    preparedXhr.responseType = 'arraybuffer';
    return client_lib_js_common_request_1.request(url, options, preparedXhr);
};
exports.widevineResponseHandler = function (response) { return response.responseText; };
